import React, { Component } from 'react';
import queryString from 'query-string';
import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';
import Jumbotron from 'react-bootstrap/Jumbotron';

import './UnauthorizedUser.css';


class UnauthorizedUser extends Component {
  get query() {
    return this.props.query || queryString.parse(window.location.search);
  }

  reSignIn() {
    if (!this.props.onSignIn) {
      return;
    }
    this.props.onSignIn();
  }

  renderMessage() {
    const { domain } = this.query;
    const restricted = domain || this.props.whitelist_auth;
    return <>
      <div className='NotAuthorizedMessage'>
        {this.props.title} へのアクセス権がありません。{restricted} にのみ許可されています。
      </div>
      <Alert variant='danger'>
        以下のボタンをクリックして一度ログアウトし、{domain || '適切なGoogleアカウント'}でのログインをお願いします。
      </Alert>
    </>
  }

  render() {
    return <Jumbotron>
      <h1>{this.props.title}</h1>
      <div className='DashboardLogin'>
        {this.renderMessage()}
      </div>
      <Button
        data-test-cloze-re-sign-in
        onClick={e => this.reSignIn()}
        variant='primary'>
        ログアウトして再ログイン
      </Button>
    </Jumbotron>
  }
}

export default UnauthorizedUser;
